// extracted by mini-css-extract-plugin
export default {"sub_title_secondary":"styles_sub_title_secondary__-WrAx"};